// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kanban {
    display: flex;
    gap: 20px;
    height: 100%;
    box-sizing: border-box;
    position: relative;
}

.column {
    background: #f8f9fa;
    width: 320px;
    min-height: 500px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    transition: all 0.2s ease;
    position: relative;
    z-index: 1 !important;
}

.columnHeader {
    border-radius: 12px 12px 0 0;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    position: relative;
    background: white;
}

.columnHeader::after {
    content: "";
    position: absolute;
    bottom: 5px;
    left: 15px;
    right: 15px;
    height: 1px;
    background: #ddd;
}

.countBadge {
    background: #6c757d;
    color: white;
    border-radius: 50%;
    padding: 4px 10px;
    font-size: 12px;
}

.cards {
    flex-grow: 1;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 50px;
    position: relative;
    z-index: 1;
    background: #f8f9fa;
    border-radius: 0 0 12px 12px;
}

.cardWrapper {
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.2s ease;
    position: relative;
    z-index: auto;
}

.cardWrapper[data-is-dragging="true"] {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25) !important;
    border: 2px solid #2196f3 !important;
    background: #fff !important;
    opacity: 0.95 !important;
    transform: rotate(2deg);
}

.cardWrapper[data-is-dragging="true"] * {
    pointer-events: none;
}

.cards[data-is-dragging-over="true"] {
    background-color: #e3f2fd !important;
    border: 2px dashed #2196f3 !important;
}

.cards > div[style*="display: none"] {
    display: block !important;
    visibility: hidden;
}

[data-rbd-drag-handle-context-id] {
    position: relative !important;
}

[data-rbd-draggable-id][style*="position: fixed"] {
    z-index: 999999 !important;
}

.kanban [data-rbd-droppable-id] {
    transform: none !important;
    position: static !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Kanban/Kanban.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,sDAAsD;IACtD,oCAAoC;IACpC,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":[".kanban {\n    display: flex;\n    gap: 20px;\n    height: 100%;\n    box-sizing: border-box;\n    position: relative;\n}\n\n.column {\n    background: #f8f9fa;\n    width: 320px;\n    min-height: 500px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    flex-shrink: 0;\n    transition: all 0.2s ease;\n    position: relative;\n    z-index: 1 !important;\n}\n\n.columnHeader {\n    border-radius: 12px 12px 0 0;\n    padding: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-weight: bold;\n    position: relative;\n    background: white;\n}\n\n.columnHeader::after {\n    content: \"\";\n    position: absolute;\n    bottom: 5px;\n    left: 15px;\n    right: 15px;\n    height: 1px;\n    background: #ddd;\n}\n\n.countBadge {\n    background: #6c757d;\n    color: white;\n    border-radius: 50%;\n    padding: 4px 10px;\n    font-size: 12px;\n}\n\n.cards {\n    flex-grow: 1;\n    padding: 15px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    min-height: 50px;\n    position: relative;\n    z-index: 1;\n    background: #f8f9fa;\n    border-radius: 0 0 12px 12px;\n}\n\n.cardWrapper {\n    background: #fff;\n    border-radius: 8px;\n    padding: 12px;\n    margin-bottom: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n    transition: box-shadow 0.2s ease;\n    position: relative;\n    z-index: auto;\n}\n\n.cardWrapper[data-is-dragging=\"true\"] {\n    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25) !important;\n    border: 2px solid #2196f3 !important;\n    background: #fff !important;\n    opacity: 0.95 !important;\n    transform: rotate(2deg);\n}\n\n.cardWrapper[data-is-dragging=\"true\"] * {\n    pointer-events: none;\n}\n\n.cards[data-is-dragging-over=\"true\"] {\n    background-color: #e3f2fd !important;\n    border: 2px dashed #2196f3 !important;\n}\n\n.cards > div[style*=\"display: none\"] {\n    display: block !important;\n    visibility: hidden;\n}\n\n[data-rbd-drag-handle-context-id] {\n    position: relative !important;\n}\n\n[data-rbd-draggable-id][style*=\"position: fixed\"] {\n    z-index: 999999 !important;\n}\n\n.kanban [data-rbd-droppable-id] {\n    transform: none !important;\n    position: static !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
